import { LoaderCircle } from "lucide-react";
import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

export interface SpinnerProps extends Omit<ComponentProps<"svg">, "children"> {
  size?: "sm" | "md" | "lg";
  /** Accessible label. Defaults to "Loading". */
  label?: string;
}

const sizes = { sm: "size-3.5", md: "size-4", lg: "size-6" } as const;

export function Spinner({ size = "md", label = "Loading", className, ...props }: SpinnerProps) {
  return (
    <LoaderCircle
      data-slot="spinner"
      role="status"
      aria-label={label}
      className={cn(
        "shrink-0 animate-spin text-fg-muted motion-reduce:animate-none",
        sizes[size],
        className,
      )}
      {...props}
    />
  );
}
